(function(){
  if (window.__alMarketPromoTiers) {
    return;
  }

  var SEG = 100 / 3;
  var controller = {};
  var lastCart = null;

  function renderTemplate(template, amount) {
    return String(template || '').replace('{amount}', amount);
  }

  function friendlyIncrement(amount) {
    if (amount < 250) return 5;
    if (amount < 1000) return 10;
    if (amount < 2500) return 50;
    if (amount < 25000) return 500;
    if (amount < 100000) return 1000;
    if (amount < 250000) return 5000;
    if (amount < 1000000) return 10000;
    return Math.pow(10, Math.max(0, Math.floor(Math.log10(amount)) - 1));
  }

  function roundUpFriendly(amount) {
    var increment = friendlyIncrement(amount);
    return Math.ceil((amount - Number.EPSILON) / increment) * increment;
  }

  function currencyContext(cart, el) {
    var locale = document.documentElement.lang || el.dataset.locale || 'fr-FR';
    var shopifyCurrency = window.Shopify && window.Shopify.currency ? window.Shopify.currency : {};
    var currency = cart.currency || shopifyCurrency.active || el.dataset.marketCurrency || 'EUR';
    var rawRate = shopifyCurrency.rate;
    var rate = Number(rawRate || 1);
    if (!Number.isFinite(rate) || rate <= 0) rate = 1;
    var currencyFormatter;
    var formatter;
    try {
      currencyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
      formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } catch (error) {
      currencyFormatter = new Intl.NumberFormat('en', { style: 'currency', currency: currency });
      formatter = new Intl.NumberFormat('en', { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
    var digits = currencyFormatter.resolvedOptions().maximumFractionDigits;
    var factor = Math.pow(10, digits);
    return {
      currency: currency,
      rate: rate,
      formatter: formatter,
      factor: factor,
      valid: currency === 'EUR' || (rawRate != null && Number(rawRate) > 0)
    };
  }

  function thresholds(el, context) {
    return [el.dataset.baseT1, el.dataset.baseT2, el.dataset.baseT3].map(function(base) {
      return Math.round(roundUpFriendly(Number(base) * context.rate) * context.factor);
    });
  }

  function fillPct(total, values) {
    if (total <= 0) return 0;
    if (total < values[0]) return total / values[0] * SEG;
    if (total < values[1]) return SEG + (total - values[0]) / (values[1] - values[0]) * SEG;
    if (total < values[2]) return (SEG * 2) + (total - values[1]) / (values[2] - values[1]) * SEG;
    return 100;
  }

  function updateElement(el, cart) {
    var context = currencyContext(cart, el);
    if (!context.valid) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    var values = thresholds(el, context);
    var qualifyingTotal = Number.isFinite(cart.items_subtotal_price)
      ? cart.items_subtotal_price
      : (Number.isFinite(cart.original_total_price) ? cart.original_total_price : (cart.total_price || 0));
    var thresholdTemplate = el.dataset.thresholdTemplate;

    values.forEach(function(threshold, index) {
      var card = el.querySelector('[data-dt3-card="' + (index + 1) + '"]');
      var thresholdText = el.querySelector('[data-dt3-threshold="' + (index + 1) + '"]');
      if (card) card.classList.toggle('is-reached', qualifyingTotal >= threshold);
      if (thresholdText) {
        thresholdText.textContent = renderTemplate(thresholdTemplate, context.formatter.format(threshold / context.factor));
      }
    });

    var percent = Math.max(0, Math.min(100, fillPct(qualifyingTotal, values)));
    var fill = el.querySelector('[data-dt3-fill]');
    var progress = el.querySelector('[data-dt3-progress]');
    if (fill) fill.style.width = percent + '%';
    if (progress) progress.setAttribute('aria-valuenow', String(Math.round(percent)));

    var hint = el.querySelector('[data-dt3-hint]');
    if (hint) {
      var template;
      var difference;
      if (qualifyingTotal < values[0]) {
        template = el.dataset.remainingFree;
        difference = values[0] - qualifyingTotal;
      } else if (qualifyingTotal < values[1]) {
        template = el.dataset.remainingDiscountTen;
        difference = values[1] - qualifyingTotal;
      } else if (qualifyingTotal < values[2]) {
        template = el.dataset.remainingDiscountFifteen;
        difference = values[2] - qualifyingTotal;
      } else {
        hint.textContent = el.dataset.complete;
      }
      if (template) {
        hint.innerHTML = renderTemplate(template, '<strong>' + context.formatter.format(difference / context.factor) + '</strong>');
      }
    }

    el.dataset.currency = context.currency;
    el.classList.add('is-ready');
  }

  function updateAll(cart) {
    lastCart = cart;
    document.querySelectorAll('[data-dt3]').forEach(function(el) {
      updateElement(el, cart);
    });
  }

  function cartUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function initialCart() {
    var el = document.querySelector('[data-dt3]');
    if (!el) return null;
    var itemsSubtotal = Number(el.dataset.cartItemsSubtotal);
    var originalTotal = Number(el.dataset.cartOriginalTotal);
    var total = Number(el.dataset.cartTotal);
    if (![itemsSubtotal, originalTotal, total].every(Number.isFinite)) return null;
    return {
      items_subtotal_price: itemsSubtotal,
      original_total_price: originalTotal,
      total_price: total
    };
  }

  controller.refresh = function(cart) {
    if (cart && typeof cart === 'object') {
      updateAll(cart);
      return;
    }
    fetch(cartUrl(), { credentials: 'include', headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(updateAll)
      .catch(function() {
        updateAll(lastCart || { items_subtotal_price: 0, total_price: 0 });
      });
  };

  function onCartEvent(event) {
    var cart = event && event.detail && event.detail.cart;
    controller.refresh(cart);
  }

  function containsNewModule(mutations) {
    return mutations.some(function(mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function(node) {
        return node.nodeType === 1 && (node.matches('[data-dt3]') || node.querySelector('[data-dt3]'));
      });
    });
  }

  window.__alMarketPromoTiers = controller;
  document.addEventListener('cart:updated', onCartEvent);
  document.addEventListener('cart:refresh', onCartEvent);
  document.addEventListener('cart:change', onCartEvent);
  document.addEventListener('shopify:section:load', function() { controller.refresh(lastCart); });
  new MutationObserver(function(mutations) {
    if (containsNewModule(mutations)) controller.refresh(lastCart);
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) controller.refresh();
  });
  var serverCart = initialCart();
  if (serverCart) updateAll(serverCart);
  else controller.refresh();
})();
